<div class="container-fluid">
  <h2>{{ 'ADMIN.PORTAL_CONTENT' | translate }}</h2>

  <app-template-editor [elementId]="'portalHelpTextId'" [height]="'40vh'" style="z-index:0"
    (onEditorKeyup)="helpText = $event" [tempValue]="helpText">
  </app-template-editor>

  <hr/>
  <h5>{{ 'ADMIN.ATTACHMENTS' | translate }}</h5>

  <input type="file" #fileInput style="display:none" multiple
    accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,image/*"
    (change)="onFilesSelected($event)">

  <button class="btn btn-outline-secondary btn-sm mb-2" (click)="fileInput.click()">
    + {{ 'ADMIN.ATTACH_FILE' | translate }}
  </button>

  @if (documents.length > 0) {
    <table class="table table-sm">
      <thead>
        <tr>
          <th>{{ 'ADMIN.FILE_NAME' | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (doc of documents; track doc) {
          <tr>
            <td>{{ doc.originalname }}</td>
            <td class="text-right">
              <button class="btn btn-sm btn-outline-danger" (click)="deleteDocument(doc)">
                {{ 'ADMIN.DELETE' | translate }}
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  <hr/>
  <h5>{{ 'PORTAL.CONTACT_TITLE' | translate }}</h5>

  @for (row of contactInfo; track $index; let i = $index) {
    <div class="row mb-2">
      <div class="col-3">
        <input type="text" class="form-control" [(ngModel)]="row.label" [name]="'contactLabel' + i" placeholder="Label">
      </div>
      <div class="col-4">
        <input type="text" class="form-control" [(ngModel)]="row.value" [name]="'contactValue' + i" placeholder="Value">
      </div>
      <div class="col-3">
        <select class="form-control" [(ngModel)]="row.type" [name]="'contactType' + i">
          <option value="email">{{ 'PORTAL.CONTACT_TYPE_EMAIL' | translate }}</option>
          <option value="phone">{{ 'PORTAL.CONTACT_TYPE_PHONE' | translate }}</option>
          <option value="text">{{ 'PORTAL.CONTACT_TYPE_TEXT' | translate }}</option>
        </select>
      </div>
      <div class="col-2">
        <button class="btn btn-outline-danger btn-sm" (click)="removeContactRow(i)">{{ 'ADMIN.DELETE' | translate }}</button>
      </div>
    </div>
  }
  <button class="btn btn-outline-secondary btn-sm mb-3" (click)="addContactRow()">+ {{ 'PORTAL.CONTACT_ADD' | translate }}</button>

  <br/>
  <button class="btn btn-outline-primary btn-lg" (click)="save()">
    <span class="glyphicon glyphicon-save"></span> {{ 'ADMIN.SAVE' | translate }}
  </button>
</div>
